import axios from 'axios'

export const case_category_service = {

  async get_my_case_categories() {
    return axios.get(`get-my-case-categories`)
  },

}